import { TagList } from "components/tags";
import { useCreatorTagsQuery } from "queries";

import "./style/FilterByTag.scss";

interface IFilterByTag {
  topic: string;
  userId: string;
  selectedTags: string[];
  changeTags: (name: string) => void;
}

const adaptTags = (data: any) => {
  const tags = Object.keys(data);

  return tags.map(tag => ({ name: tag, count: 0 }));
};

export const FilterByTag = ({ topic, userId, changeTags, selectedTags }: IFilterByTag) => {
  const { isLoading, isError, data } = useCreatorTagsQuery(userId);

  if (isLoading) {
    return <p>loading...</p>;
  }

  if (isError) {
    return <p>Error loading tags....</p>;
  }

  const getTagList = () => {
    if (topic === "i") {
      return adaptTags(data.tags.images);
    }

    if (topic === "g") {
      return adaptTags(data.tags.gifs);
    }

    return adaptTags(data.tags.all);
  };

  const tagList = getTagList();

  if (!tagList.length) {
    return null;
  }

  return (
    <div className="FilterByTag">
      <p className="FilterByTag-Title">Filter by Tags</p>
      <TagList
        tags={tagList}
        selectedTags={selectedTags}
        changeTags={changeTags}
        secondRow
      />
    </div>
  );
};
